import { createContext } from "react";

const SocketContext = createContext({
  client: null,
  setClient: () => {},
  userLoggedIn: async () => {},
});

export default SocketContext;
